<template>
  <div class="choix-role-backdrop">
    <div class="choix-role" role="dialog">
      <header class="titre">
        <slot name="header"> Choix de Rôle </slot>
      </header>

      <section class="choix-role-body">
        <td>
          <Dropdown
            v-model="role"
            :options="listeRoles"
            optionValue="valeur"
            optionLabel="texte"
            scrollHeight="500px"
          />
        </td>
      </section>

      <footer class="choix-role-footer">
        <Button type="button" @click="lier(dossierALier)"> Ok </Button>
        <Button type="button" @click="fermerChoixRole"> Annuler </Button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChoixRole",
  props: ["listeRoles"],
  emits: ["fermerChoixRole", "lier"],
  data() {
    return {
      role: null,
    };
  },
  methods: {
    fermerChoixRole() {
      this.role = null;
      this.$emit("fermerChoixRole");
    },
    lier() {
      this.$emit("lier", this.role);
    },
  },
};
</script>
